import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import Styles from "../Components/Store/AllProducts/AllProducts.module.css";
import { addCustomerProductSuggestionService } from "../Services/ApiServices";
import Loader from "../SharedComponents/Loader/Loader";

const SuggestionBox = ({ show, handleClose, initialProductName }) => {
  const [isLoading, setisLoading] = useState(false);
  const formik = useFormik({
    initialValues: {
      brand: "",
      product: initialProductName || "",
      unit: "",
      description: "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      brand: Yup.string(),
      product: Yup.string().required("Product name is required"),
      unit: Yup.string(),
      description: Yup.string(),
    }),
    onSubmit: (values) => {
      addSuggestionApiCall();
    },
  });

  const addSuggestionApiCall = () => {
    setisLoading(true);
    const customerLog = JSON.parse(sessionStorage.getItem("customerlog"));
    const customerId = JSON.parse(sessionStorage.getItem("customer_id"));

    const formData = new FormData();
    formData.append("franchise_id", customerLog?.id);
    formData.append("customer_id", customerId);
    formData.append("product_name", formik.values.product);
    formData.append("brand_name", formik.values.brand);
    formData.append("units", formik.values.unit);
    formData.append("description", formik.values.description);

    addCustomerProductSuggestionService(formData)
      .then((res) => {
        formik.resetForm();
        handleClose();
        toast.success("Thanks! You asked. We’ll bring it soon…");
      })
      .catch((err) => {
        toast.error("Something went wrong!!", { type: "error" });
      })
      .finally(() => {
        setisLoading(false);
      });
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton className="border-0">
        <Modal.Title className="fontBold">You Ask. We Stock.</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={formik.handleSubmit}>
          <div className="mb-3">
            <label className="label mb-1">Product Name</label>
            <input
              name="product"
              type="text"
              className={`form-control kstoreFont2 ${
                formik.touched.product && formik.errors.product
                  ? "is-invalid"
                  : ""
              }`}
              placeholder="Enter Product Name"
              value={formik.values.product}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.product && formik.errors.product && (
              <div className="invalid-feedback d-block">
                {formik.errors.product}
              </div>
            )}
          </div>
          <div className="mb-3">
            <label className="label mb-1">Brand Name</label>
            <input
              name="brand"
              type="text"
              className={`form-control kstoreFont2 ${
                formik.touched.brand && formik.errors.brand ? "is-invalid" : ""
              }`}
              placeholder="Enter Brand Name"
              value={formik.values.brand}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.brand && formik.errors.brand && (
              <div className="invalid-feedback d-block">
                {formik.errors.brand}
              </div>
            )}
          </div>
          <div className="mb-3">
            <label className="label mb-1">Unit</label>
            <input
              name="unit"
              type="text"
              className={`form-control kstoreFont2 ${
                formik.touched.unit && formik.errors.unit ? "is-invalid" : ""
              }`}
              placeholder="Specify unit (e.g. 500g, 1kg, 1L)"
              value={formik.values.unit}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.unit && formik.errors.unit && (
              <div className="invalid-feedback d-block">
                {formik.errors.unit}
              </div>
            )}
          </div>
          <div className="mb-3">
            <label className="label mb-1">Description</label>
            <textarea
              name="description"
              rows={3}
              className="form-control kstoreFont2"
              placeholder="Tell us more about the product you need..."
              value={formik.values.description}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>
          <div className="d-flex justify-content-end">
            <button
              type="submit"
              className={Styles.applyBtn + " border-0 px-4 py-2 text-white"}
              style={{ backgroundColor: "#FF7C25", borderRadius: "5px" }}
            >
              Submit
            </button>
          </div>
        </form>
        <Loader isLoader={isLoading} />
      </Modal.Body>
    </Modal>
  );
};

export default SuggestionBox;
